import { paths } from '../../common/router/routePaths';

export function isBackOffice(currentPath: string): boolean {
    return currentPath.includes(paths.backOffice.default);
}
